
import { createNamespacedHelpers } from 'vuex'
import CalendarDashboard from '~/components/global/Schedule/components/CalendarDashboard/CalendarDashboard.vue'
import ProgramListLoader from '~/components/pages/education/ProgramsList/ProgramListLoader.vue'
import { gbLocalStorage } from '~/utils/helpers'
const { mapState } = createNamespacedHelpers('education')

export default {
  name: 'ClientEducation',
  components: { ProgramListLoader, CalendarDashboard },

  computed: {
    ...mapState(['isStudentDataLoading', 'isSettingsChanged']),
    switcherData() {
      const currentVersion = this.$route.hash === '#test'

      return currentVersion
        ? {
            title: 'К старой версии',
            description:
              'Столкнулись с трудностями на новой странице или нашли ошибку? Расскажите об этом в чате поддержки или вернитесь к старой версии.',

            button: 'Вернуться',
            link: '/education'
          }
        : {
            title: 'К новой версии страницы',
            description:
              'Для вас доступна новая версия страницы Мое Обучение! Возможные ошибки носят временный характер.',

            button: 'Попробовать',
            link: '/education#test'
          }
    }
  },

  async mounted() {
    await this.$store.dispatch('education/getBlocks')
  },

  async activated() {
    this.checkVersion()

    if (this.isSettingsChanged) {
      this.$store.commit('education/set', {
        type: 'isSettingsChanged',
        payload: false
      })
      await this.$store.dispatch('education/getBlocks')
    }
  },

  methods: {
    checkVersion() {
      const currentVersion = gbLocalStorage.get('gb-education-current-version')

      if (currentVersion === 'new') {
        this.$router.push('/education#test')
      } else {
        this.$router.push('/education')
      }
    }
  }
}
